import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { FormattedMessage } from "react-intl";

interface ArchiveConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  error: string | null;
  isArchive: boolean; // true for archive, false for unarchive
  className?: string;
}

export default function ArchiveConfirmDialog({
  open,
  onClose,
  onConfirm,
  error,
  isArchive,
  className,
}: ArchiveConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <DialogTitle>
        <FormattedMessage
          id={
            isArchive
              ? "admin.dashboard.archiveClassConfirmTitle"
              : "admin.dashboard.unarchiveClassConfirmTitle"
          }
        />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage
            id={
              isArchive
                ? "admin.dashboard.archiveClassConfirmMessage"
                : "admin.dashboard.unarchiveClassConfirmMessage"
            }
            values={{ className }}
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          <FormattedMessage id="admin.dashboard.cancel" />
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          <FormattedMessage id="admin.dashboard.confirm" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
